import { createSlice } from '@reduxjs/toolkit';
import ApiClient, { createFetchErrorMessage } from 'utils/api/ApiClient';

const initialState = {loading:null, result:null};
const userFollowingListSlice = createSlice({
    name: 'userFollowingList',
    initialState,
    reducers: {
        loading: (state) => {
            state.loading = true;
            state.result = null;
        },
        fetch: (state, action) => {
            state.loading = false;
            console.log(action.payload);
        }
    }
});


export const userFollowingListActions = userFollowingListSlice.actions;
export default userFollowingListSlice.reducer;


export const fetchUserFollowingList = (id) => {

    return (dispatch) => {
        dispatch( userFollowingListActions.loading() );

        const { promise } = ApiClient({
            method: "get",
            url: `/api/user/${id}/following/list`,
            authToken: sessionStorage.getItem("user"),
        });

        promise.then((res) => {
            dispatch( userFollowingListActions.fetch(res.data) );
        }).catch((err) => {
            const errorData = createFetchErrorMessage(err);
            console.log(errorData.message);
        });
    };

};


export const userFollowing = (id) => {

    return async () => {
        return await ApiClient({
            method: "get",
            url: `/api/user/${id}/following`,
            authToken: sessionStorage.getItem("user"),
        });
    };

};